import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            const saved = localStorage.getItem("abnormal_lang");
            if (saved === "it" || saved === "en") return saved;
        } catch { /* ignore */ }
        const nav = (typeof navigator !== "undefined" && navigator.language) ? navigator.language.slice(0, 2) : "it";
        return nav === "en" ? "en" : "it";
    });

    useEffect(() => {
        try { localStorage.setItem("abnormal_lang", lang); } catch { /* ignore */ }
        if (typeof document !== "undefined") document.documentElement.lang = lang;
    }, [lang]);

    const value = useMemo(() => {
        const dict = translations[lang] || translations.it;
        const t = (path) => {
            const keys = String(path).split(".");
            let curr = dict;
            for (const k of keys) {
                if (curr && typeof curr === "object" && k in curr) curr = curr[k];
                else return path;
            }
            return curr;
        };
        return { lang, setLang, t };
    }, [lang]);

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
}
